module.exports = __webpack_public_path__ + "img/logo-cer.51a259bf.webp";